import React, { useEffect, useState } from "react";
import WaitForSettlementDetail from "./waitForSettlementDetail";
import WaitForSettlementByCustomer from "./waitForSettlementByCustomer";
import { useMutation } from "react-query";
import {
  GetGroupedSales,
  GetSalesByCustomerSearch,
} from "../../../services/supplier.service";
import TableRowSkeleton from "../../../components/skeletons/TableRowSkeleton";
import {
  getGroupedSalesResponse,
  getSalesByCustomerSearchRequest,
  IcustomerInfo,
  IResult,
} from "../../../models/supplier.model";
import { ApiResultModel, PageInfoModel } from "../../../models/common.model";
import { ISaleItemRequest } from "../../../models/sale.model";
import { SALE_ITEM } from "../../../config/cacheKey";

export default function WaitForSettlement() {
  const [data, setData] = useState<getGroupedSalesResponse>();
  const request = {} as ISaleItemRequest;
  request.from = "waitForSettlement";
  localStorage.setItem(SALE_ITEM, JSON.stringify(request));
  // const [icustomerInfoData, setIcustomerInfoData] = useState<IResult[]>([]);
  let icustomerInfoData: any[] = [];
  const [isShow, setIsShow] = useState(true);
  const [getPageInfo, setGetPageInfo] = useState<PageInfoModel>();
  const [state, setState] = useState<
    "waitForSettlementDetail" | "waitForSettlementByCustomer"
  >();
  const { mutateAsync: GetGroupedSalesMutate } = useMutation(GetGroupedSales, {
    onSuccess: (data: ApiResultModel<getGroupedSalesResponse>) => {
      const pageInfo = new PageInfoModel();
      pageInfo.pageNumber = data.data.groupedByBranches.pageNumber;
      pageInfo.pageSize = data.data.groupedByBranches.pageSize;
      pageInfo.total = data.data.groupedByBranches.totalCount;
      setGetPageInfo(pageInfo);
      setData(data.data);
      if (
        (data && data.data.groupedByBranches.result.length > 0) ||
        data.data.groupedByIban.result.length > 0
      ) {
        if (
          data.data.groupedByBranches.result.length > 1 ||
          data.data.groupedByIban.result.length > 0
        ) {
          setState("waitForSettlementDetail");
        } else {
          setState("waitForSettlementByCustomer");
        }
      }
    },
  });

  useEffect(() => {
    const request = new getSalesByCustomerSearchRequest();
    GetGroupedSalesMutate(request);
  }, []);
  // if (!state) {
  //   return <TableRowSkeleton rowsNum={10} columnsNum={8} width={120} />;
  // }
  const curerntState = {
    waitForSettlementDetail: (
      <WaitForSettlementDetail
        groupedByBranches={data?.groupedByBranches}
        groupedByIban={data?.groupedByIban}
        getPageInfo={getPageInfo}
      />
    ),
    waitForSettlementByCustomer: <WaitForSettlementByCustomer />,
  };
  return <div>{curerntState[state!]}</div>;
}
